import { render, staticRenderFns } from "./CpeDetails.vue?vue&type=template&id=2aac284f&"
import script from "./CpeDetails.vue?vue&type=script&lang=js&"
export * from "./CpeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports